import { GetBillingCycleInvoicesResponseSchema, type GetBillingCycleInvoicesResponse } from '@weft/api-definition';
import { purge, withDefault } from '@weft/utils';
import { getPrivateApi } from 'apps/app/src/services/api';
import { useQuery } from 'react-query';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { BILLING_CYCLE_INVOICES_DEFAULT_PAGE_SIZE } from './use-billing-cycle-invoices-consts';

type UseBillingCycleInvoicesPayload = Parameters<ReturnType<typeof getPrivateApi>['getBillingCycleInvoices']>[0];

export function useBillingCycleInvoices(payload: UseBillingCycleInvoicesPayload = {}, options?: CustomUseQueryOptions<GetBillingCycleInvoicesResponse>) {
  return useQuery(
    ['billing-cycle-invoices', ...purge(Object.values(payload))],
    async ({ signal }) => {
      const invoicesApi = getPrivateApi();
      const getBillingCycleInvoicesResponse = await invoicesApi.getBillingCycleInvoices({
        page: withDefault(payload.page, 0),
        pageSize: withDefault(payload.pageSize, BILLING_CYCLE_INVOICES_DEFAULT_PAGE_SIZE),
        ...payload,
      }, { signal });

      return GetBillingCycleInvoicesResponseSchema.parse(getBillingCycleInvoicesResponse);
    },
    { keepPreviousData: true, ...options },
  );
}